/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ChatsRouteImport } from './routes/chats'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppBusinessKnowledgeRouteImport } from './routes/_app.business-knowledge'
import { Route as AppDataRouteImport } from './routes/_app.data'
import { Route as AppKnowledgeBaseRouteImport } from './routes/_app.knowledge-base'
import { Route as AppReportsRouteImport } from './routes/_app.reports'
import { Route as DashboardsIndexRouteImport } from './routes/dashboards.index'
import { Route as DashboardsIdRouteImport } from './routes/dashboards.$id'
import { Route as AppChatIdRouteImport } from './routes/_app.chat.$id'
import { Route as AppKnowledgeBaseIndexRouteImport } from './routes/_app.knowledge-base.index'
import { Route as AppKnowledgeBaseKbIdRouteImport } from './routes/_app.knowledge-base.$kbId'
import { Route as AppProjectsIndexRouteImport } from './routes/_app.projects.index'
import { Route as AppProjectsIdRouteImport } from './routes/_app.projects.$id'
import { Route as AppShareTokenRouteImport } from './routes/_app.share.$token'
import { Route as AppKnowledgeBaseKbIdIndexRouteImport } from './routes/_app.knowledge-base.$kbId.index'
import { Route as AppShareMessageTokenRouteImport } from './routes/_app.share.message.$token'

const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatsRoute = ChatsRouteImport.update({
  id: '/chats',
  path: '/chats',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppBusinessKnowledgeRoute = AppBusinessKnowledgeRouteImport.update({
  id: '/business-knowledge',
  path: '/business-knowledge',
  getParentRoute: () => AppRoute,
} as any)
const AppDataRoute = AppDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => AppRoute,
} as any)
const AppKnowledgeBaseRoute = AppKnowledgeBaseRouteImport.update({
  id: '/knowledge-base',
  path: '/knowledge-base',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const DashboardsIndexRoute = DashboardsIndexRouteImport.update({
  id: '/dashboards/',
  path: '/dashboards/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardsIdRoute = DashboardsIdRouteImport.update({
  id: '/dashboards/$id',
  path: '/dashboards/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AppChatIdRoute = AppChatIdRouteImport.update({
  id: '/chat/$id',
  path: '/chat/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppKnowledgeBaseIndexRoute = AppKnowledgeBaseIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppKnowledgeBaseRoute,
} as any)
const AppKnowledgeBaseKbIdRoute = AppKnowledgeBaseKbIdRouteImport.update({
  id: '/$kbId',
  path: '/$kbId',
  getParentRoute: () => AppKnowledgeBaseRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIdRoute = AppProjectsIdRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppShareTokenRoute = AppShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => AppRoute,
} as any)
const AppKnowledgeBaseKbIdIndexRoute =
  AppKnowledgeBaseKbIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppKnowledgeBaseKbIdRoute,
  } as any)
const AppShareMessageTokenRoute = AppShareMessageTokenRouteImport.update({
  id: '/share/message/$token',
  path: '/share/message/$token',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/': typeof AppIndexRoute
  '/chats': typeof ChatsRoute
  '/login': typeof LoginRoute
  '/business-knowledge': typeof AppBusinessKnowledgeRoute
  '/data': typeof AppDataRoute
  '/knowledge-base': typeof AppKnowledgeBaseRouteWithChildren
  '/reports': typeof AppReportsRoute
  '/dashboards/$id': typeof DashboardsIdRoute
  '/dashboards/': typeof DashboardsIndexRoute
  '/chat/$id': typeof AppChatIdRoute
  '/knowledge-base/$kbId': typeof AppKnowledgeBaseKbIdRouteWithChildren
  '/projects/$id': typeof AppProjectsIdRoute
  '/share/$token': typeof AppShareTokenRoute
  '/knowledge-base/': typeof AppKnowledgeBaseIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/share/message/$token': typeof AppShareMessageTokenRoute
  '/knowledge-base/$kbId/': typeof AppKnowledgeBaseKbIdIndexRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/chats': typeof ChatsRoute
  '/login': typeof LoginRoute
  '/business-knowledge': typeof AppBusinessKnowledgeRoute
  '/data': typeof AppDataRoute
  '/reports': typeof AppReportsRoute
  '/dashboards/$id': typeof DashboardsIdRoute
  '/': typeof AppIndexRoute
  '/dashboards': typeof DashboardsIndexRoute
  '/chat/$id': typeof AppChatIdRoute
  '/projects/$id': typeof AppProjectsIdRoute
  '/share/$token': typeof AppShareTokenRoute
  '/knowledge-base': typeof AppKnowledgeBaseIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/share/message/$token': typeof AppShareMessageTokenRoute
  '/knowledge-base/$kbId': typeof AppKnowledgeBaseKbIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/_app': typeof AppRouteWithChildren
  '/chats': typeof ChatsRoute
  '/login': typeof LoginRoute
  '/_app/business-knowledge': typeof AppBusinessKnowledgeRoute
  '/_app/data': typeof AppDataRoute
  '/_app/knowledge-base': typeof AppKnowledgeBaseRouteWithChildren
  '/_app/reports': typeof AppReportsRoute
  '/dashboards/$id': typeof DashboardsIdRoute
  '/_app/': typeof AppIndexRoute
  '/dashboards/': typeof DashboardsIndexRoute
  '/_app/chat/$id': typeof AppChatIdRoute
  '/_app/knowledge-base/$kbId': typeof AppKnowledgeBaseKbIdRouteWithChildren
  '/_app/projects/$id': typeof AppProjectsIdRoute
  '/_app/share/$token': typeof AppShareTokenRoute
  '/_app/knowledge-base/': typeof AppKnowledgeBaseIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/share/message/$token': typeof AppShareMessageTokenRoute
  '/_app/knowledge-base/$kbId/': typeof AppKnowledgeBaseKbIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/'
    | '/chats'
    | '/login'
    | '/business-knowledge'
    | '/data'
    | '/knowledge-base'
    | '/reports'
    | '/dashboards/$id'
    | '/dashboards/'
    | '/chat/$id'
    | '/knowledge-base/$kbId'
    | '/projects/$id'
    | '/share/$token'
    | '/knowledge-base/'
    | '/projects/'
    | '/share/message/$token'
    | '/knowledge-base/$kbId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/chats'
    | '/login'
    | '/business-knowledge'
    | '/data'
    | '/reports'
    | '/dashboards/$id'
    | '/'
    | '/dashboards'
    | '/chat/$id'
    | '/projects/$id'
    | '/share/$token'
    | '/knowledge-base'
    | '/projects'
    | '/share/message/$token'
    | '/knowledge-base/$kbId'
  id:
    | '__root__'
    | '/$'
    | '/_app'
    | '/chats'
    | '/login'
    | '/_app/business-knowledge'
    | '/_app/data'
    | '/_app/knowledge-base'
    | '/_app/reports'
    | '/dashboards/$id'
    | '/_app/'
    | '/dashboards/'
    | '/_app/chat/$id'
    | '/_app/knowledge-base/$kbId'
    | '/_app/projects/$id'
    | '/_app/share/$token'
    | '/_app/knowledge-base/'
    | '/_app/projects/'
    | '/_app/share/message/$token'
    | '/_app/knowledge-base/$kbId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  AppRoute: typeof AppRouteWithChildren
  ChatsRoute: typeof ChatsRoute
  LoginRoute: typeof LoginRoute
  DashboardsIdRoute: typeof DashboardsIdRoute
  DashboardsIndexRoute: typeof DashboardsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chats': {
      id: '/chats'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof ChatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/business-knowledge': {
      id: '/_app/business-knowledge'
      path: '/business-knowledge'
      fullPath: '/business-knowledge'
      preLoaderRoute: typeof AppBusinessKnowledgeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data': {
      id: '/_app/data'
      path: '/data'
      fullPath: '/data'
      preLoaderRoute: typeof AppDataRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/knowledge-base': {
      id: '/_app/knowledge-base'
      path: '/knowledge-base'
      fullPath: '/knowledge-base'
      preLoaderRoute: typeof AppKnowledgeBaseRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/dashboards/': {
      id: '/dashboards/'
      path: '/dashboards'
      fullPath: '/dashboards/'
      preLoaderRoute: typeof DashboardsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboards/$id': {
      id: '/dashboards/$id'
      path: '/dashboards/$id'
      fullPath: '/dashboards/$id'
      preLoaderRoute: typeof DashboardsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/chat/$id': {
      id: '/_app/chat/$id'
      path: '/chat/$id'
      fullPath: '/chat/$id'
      preLoaderRoute: typeof AppChatIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/knowledge-base/': {
      id: '/_app/knowledge-base/'
      path: '/'
      fullPath: '/knowledge-base/'
      preLoaderRoute: typeof AppKnowledgeBaseIndexRouteImport
      parentRoute: typeof AppKnowledgeBaseRoute
    }
    '/_app/knowledge-base/$kbId': {
      id: '/_app/knowledge-base/$kbId'
      path: '/$kbId'
      fullPath: '/knowledge-base/$kbId'
      preLoaderRoute: typeof AppKnowledgeBaseKbIdRouteImport
      parentRoute: typeof AppKnowledgeBaseRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$id': {
      id: '/_app/projects/$id'
      path: '/projects/$id'
      fullPath: '/projects/$id'
      preLoaderRoute: typeof AppProjectsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/share/$token': {
      id: '/_app/share/$token'
      path: '/share/$token'
      fullPath: '/share/$token'
      preLoaderRoute: typeof AppShareTokenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/knowledge-base/$kbId/': {
      id: '/_app/knowledge-base/$kbId/'
      path: '/'
      fullPath: '/knowledge-base/$kbId/'
      preLoaderRoute: typeof AppKnowledgeBaseKbIdIndexRouteImport
      parentRoute: typeof AppKnowledgeBaseKbIdRoute
    }
    '/_app/share/message/$token': {
      id: '/_app/share/message/$token'
      path: '/share/message/$token'
      fullPath: '/share/message/$token'
      preLoaderRoute: typeof AppShareMessageTokenRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppKnowledgeBaseKbIdRouteChildren {
  AppKnowledgeBaseKbIdIndexRoute: typeof AppKnowledgeBaseKbIdIndexRoute
}

const AppKnowledgeBaseKbIdRouteChildren: AppKnowledgeBaseKbIdRouteChildren = {
  AppKnowledgeBaseKbIdIndexRoute: AppKnowledgeBaseKbIdIndexRoute,
}

const AppKnowledgeBaseKbIdRouteWithChildren =
  AppKnowledgeBaseKbIdRoute._addFileChildren(AppKnowledgeBaseKbIdRouteChildren)

interface AppKnowledgeBaseRouteChildren {
  AppKnowledgeBaseKbIdRoute: typeof AppKnowledgeBaseKbIdRouteWithChildren
  AppKnowledgeBaseIndexRoute: typeof AppKnowledgeBaseIndexRoute
}

const AppKnowledgeBaseRouteChildren: AppKnowledgeBaseRouteChildren = {
  AppKnowledgeBaseKbIdRoute: AppKnowledgeBaseKbIdRouteWithChildren,
  AppKnowledgeBaseIndexRoute: AppKnowledgeBaseIndexRoute,
}

const AppKnowledgeBaseRouteWithChildren =
  AppKnowledgeBaseRoute._addFileChildren(AppKnowledgeBaseRouteChildren)

interface AppRouteChildren {
  AppBusinessKnowledgeRoute: typeof AppBusinessKnowledgeRoute
  AppDataRoute: typeof AppDataRoute
  AppKnowledgeBaseRoute: typeof AppKnowledgeBaseRouteWithChildren
  AppReportsRoute: typeof AppReportsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppChatIdRoute: typeof AppChatIdRoute
  AppProjectsIdRoute: typeof AppProjectsIdRoute
  AppShareTokenRoute: typeof AppShareTokenRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppShareMessageTokenRoute: typeof AppShareMessageTokenRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppBusinessKnowledgeRoute: AppBusinessKnowledgeRoute,
  AppDataRoute: AppDataRoute,
  AppKnowledgeBaseRoute: AppKnowledgeBaseRouteWithChildren,
  AppReportsRoute: AppReportsRoute,
  AppIndexRoute: AppIndexRoute,
  AppChatIdRoute: AppChatIdRoute,
  AppProjectsIdRoute: AppProjectsIdRoute,
  AppShareTokenRoute: AppShareTokenRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppShareMessageTokenRoute: AppShareMessageTokenRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  AppRoute: AppRouteWithChildren,
  ChatsRoute: ChatsRoute,
  LoginRoute: LoginRoute,
  DashboardsIdRoute: DashboardsIdRoute,
  DashboardsIndexRoute: DashboardsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
